import React from "react";
import { ReactComponent as Logo } from '../../misc/logo.svg';
import './logo.scss'
import SETTINGS from './../../utils/constants';


const LogoComponent=(props)=>{
    // eslint-disable-next-line react/prop-types
    const {fill}= props;
    return <Logo className="logo" fill={fill? fill: SETTINGS.LOGO_COLOR}/>
}

export default LogoComponent;